export default function () {
  var confirmed = sessionStorage.getItem('hcp-confirmed');
  if (confirmed === 'hcp') {
    return;
  } else {
    $('#overlay-hcp').css('display', 'table');
  }
  $('#overlay-hcp .button').on('click', handler_onClick_alertButton);

  function handler_onClick_alertButton(e) {
    var id = e.currentTarget.id;
    if (id === 'hcp-ok') {
      $('#overlay-hcp .overlay--wrapper--inner').animate({
        top: '+40px'
      }, {
        ease: 'ease-out'
      });
      $('#overlay-hcp').animate({
        opacity: 0
      }, {
        display: 'none',
        ease: 'ease-out',
        complete: function () {
          sessionStorage.setItem('hcp-confirmed', 'hcp');
          $('#overlay-hcp').hide();
        }
      });
    } else {
      window.location = 'http://www.melinta.com';
    }
  }
}



// WEBPACK FOOTER //
// ./js/modules/hcp-confirmation.js